// extracted by mini-css-extract-plugin
export default {"choreInfoOuter":"ChoreInfo_choreInfoOuter__WCYKU","choreName":"ChoreInfo_choreName__1V1e+","choreStatOuter":"ChoreInfo_choreStatOuter__f7HOc"};